const React = require('react');
const ReactRedux = require('react-redux');

const DeploySchedule = require('../containers/DeploySchedule.jsx');

function DeployPlanRO(props) {
	let headerTitle = "Deployment plan";
	if (!props.summary_of_changes && !props.summary_of_changes) {
		headerTitle = "Deployment plan skipped";
	}
	return (
		<div>
			<div className="section deploy-plan">
				<div className="row">
					<div className="col-md-8">
						<header><h4>{headerTitle}</h4></header>
						<div className="summary_title">{props.title}</div>
						<p className="summary_of_changes">
							{props.summary_of_changes}
						</p>
					</div>
					<DeploySchedule />
				</div>
			</div>
		</div>
	);
}

const mapStateToProps = function(state) {
	return {
		title: state.plan.title,
		summary_of_changes: state.plan.summary_of_changes
	};
};

const mapDispatchToProps = function() {
	return {};
};

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(DeployPlanRO);

